import { EstimateRow } from "features/subscriptions/components/ManageSubscription/EstimateRow";
import { useManageSubscription } from "features/subscriptions/context/ManageSubscriptionContext";
import type { InvoiceEstimate } from "features/subscriptions/types";
import {
  formatPrice,
  formatPricingPeriodInfo,
  parseEstimate,
} from "features/subscriptions/utils";

import type { PricingPeriodInfo, SubscriptionType } from "common/types";

export default function NewPrice({
  subscriptionType,
  estimate,
  pricingPeriodInfo,
  isLoading,
}: {
  subscriptionType: SubscriptionType;
  estimate: InvoiceEstimate | undefined;
  pricingPeriodInfo: PricingPeriodInfo;
  isLoading: boolean;
}) {
  const { hasActiveSubscription } = useManageSubscription();

  let rowLabel = subscriptionType === "rental" ? "Price" : "Plan price";

  if (hasActiveSubscription) {
    rowLabel = subscriptionType === "rental" ? "New price" : "New plan price";
  }

  let previousPriceComponent: JSX.Element;
  let priceValue: number;

  if (estimate) {
    const { amountDue, coupon, creditsApplied } = parseEstimate(estimate);

    priceValue = amountDue + creditsApplied;

    if (coupon) {
      previousPriceComponent = (
        <span className="text-md-medium text-black-500 line-through">
          {formatPrice(amountDue + coupon.amount)}
        </span>
      );
    }
  }

  return (
    <EstimateRow
      label={rowLabel}
      tooltipText={
        hasActiveSubscription
          ? "The updated recurring price for your subscription plan, if you proceed with the update"
          : "The recurring price for your subscription"
      }
      valueComponent={
        <>
          {previousPriceComponent}
          <span className="text-md-bold">
            {priceValue === undefined
              ? "-"
              : `${formatPrice(priceValue)} / ${formatPricingPeriodInfo(pricingPeriodInfo)}`}
          </span>
        </>
      }
      isLoading={isLoading}
    />
  );
}
